var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3762",
    "data-name": "Rectangle 3762",
    width: 24,
    height: 24,
    transform: "translate(60 356)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_4732",
    "data-name": "Mask Group 4732",
    transform: "translate(-60 -356)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7600",
    "data-name": "Group 7600",
    transform: "translate(63.055 358.736)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7599",
    "data-name": "Group 7599",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8205",
    "data-name": "Path 8205",
    d: "M9.378,18.529a57.847,57.847,0,0,1-6.12-.33,3.4,3.4,0,0,1-1.722-.558,3.067,3.067,0,0,1-1.2-2.148A26.687,26.687,0,0,1,.15,8.435C.217,7.819.29,7.2.413,6.593A7.366,7.366,0,0,1,.8,5.5c.16-.425.331-.846.489-1.272.249-.666.511-1.328.732-2A2.675,2.675,0,0,1,4.475.275,36.422,36.422,0,0,1,12.606.186c.4.042.809.08,1.207.154a2.434,2.434,0,0,1,1.945,1.62c.4,1.076.791,2.159,1.19,3.236a8.451,8.451,0,0,1,.5,1.338,24.7,24.7,0,0,1,.352,6.628c-.075.857-.19,1.711-.313,2.562a2.808,2.808,0,0,1-2.558,2.445,53.672,53.672,0,0,1-5.556.359m-.526-1.6a52.95,52.95,0,0,0,5.956-.352,1.218,1.218,0,0,0,1.094-1,24.694,24.694,0,0,0-.009-8.8A1.487,1.487,0,0,0,14.6,5.551c-1.517-.136-3.036-.272-4.557-.333a44.924,44.924,0,0,0-6.548.293A1.574,1.574,0,0,0,1.967,6.945c-.122.793-.222,1.59-.294,2.389a23.268,23.268,0,0,0,.3,6.234A1.212,1.212,0,0,0,3.059,16.58a52.541,52.541,0,0,0,5.793.354M3.071,3.969a48.5,48.5,0,0,1,11.73,0c-.169-.462-.34-.881-.475-1.311a1.031,1.031,0,0,0-1-.781C12.113,1.783,10.9,1.652,9.688,1.6a29.543,29.543,0,0,0-5.324.3.788.788,0,0,0-.658.432c-.228.519-.414,1.056-.636,1.632",
    transform: "translate(0 0)",
    fill: "#9e9e9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8206",
    "data-name": "Path 8206",
    d: "M63.914,114.779c1.391,0,2.782,0,4.173,0a.791.791,0,0,1,.178,1.57,1.236,1.236,0,0,1-.222.019q-4.148,0-8.3,0a.8.8,0,0,1-.885-.747.772.772,0,0,1,.8-.841c.77-.008,1.54,0,2.31,0h1.938",
    transform: "translate(-54.951 -107.154)",
    fill: "#9e9e9e"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductb);
export default __webpack_public_path__ + "static/media/productb.cc5c540579291fa7d4f4ea87aaa01c3d.svg";
export { ForwardRef as ReactComponent };